<template>
  <div class="d-flex flex-column h-100 update-container">
    <header class="masthead mb-auto">
      <nav class="navbar navbar-expand-lg navbar-dark bg-no-trans">
				<div class="container-fluid">
					<a class="navbar-brand" href="/#/">
						<img src="../../assets/img/logo.png" alt="Logo" />
					</a>
					<ul class="navbar-nav ml-auto align-items-center navWithSearch">
					<li class="nav-item">
              <a class="nav-link" href="#" tabindex="-1" aria-disabled="true">
                <img
                  v-bind:src="require(`@/assets/img/${this.n}.png`)"
                  alt
                  height="40px"
                  width="40px"
                  style="vertical-align: top"
                />
              </a>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="dropdown01"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                > </a
              >
              <div
                class="dropdown-menu dropdown-menu-right front"
                aria-labelledby="dropdown01"
              >
                <span class="dropdown-menu-arrow"></span>
                <a class="dropdown-item front" href="/#/profile2"> Manage Profile</a>
                <a class="dropdown-item front" href="/#/account">Account</a>
                <a class="dropdown-item front" href="/#/mediaCenter">Help Center</a>
                <a class="dropdown-item pointer front" @click="logout">Sign Out</a>
              </div>
            </li>
					</ul>
				</div>
			</nav>
    </header>
    <section class="py-5  bg-grey200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8">
            <div class="card custom-card">
              <div class="card-body">
                <h5 class="text-center text-green mt-4">
                  UPDATE YOUR PHONE NUMBER
                </h5>
                <div class="content row justify-content-center">
                  <div class="form-group col-md-12 mt-1 mb-1">
                    <p class="emailhead">
                      Your phone number will be used if you forget your password
                      and for important account messages.
                    </p>
                  </div>
                  <div
                    v-if="
                      this.mobileVerified == false && showVerification == true
                    "
                    class="currentEmail form-group col-md-10 mt-4 mb-3 bg-grey200 justify-content-center"
                  >
                    <p class="emailhead">
                      <img
                        class="error-icon col-center"
                        src="../../assets/img/warning.svg"
                        alt=""
                      />Your Phone Number is UNVERIFIED
                    </p>
                    <p class="emailhead">
                      Your phone number must be verified before it can be used
                      to recover your account. We will text a verification code
                      to {{ this.telephone }}. Text fees may apply.
                    </p>
                    <div class="verifybtn">
                      <button
                        type="button"
                         v-on:click.stop.prevent="verifyNumber"
                        class="btn btn-verify"
                      >
                        SEND CODE
                      </button>
                    </div>
                  </div>
                  <div class="form-group input1 col-md-7 mt-3 mb-3">
                    <label class="label-text"> Mobile Phone Number </label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <button
                          class="btn btn-light dropdown-toggle"
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          ({{ countryCode }}) {{ countryName }}
                        </button>
                        <div class="dropdown-menu">
                          <a
                            class="dropdown-item"
                            href="#"
                            v-for="(countrycode, index) in countrycodes"
                            :key="index"
                            @click="onCountryCodeClicked(countrycode)"
                            >({{ countrycode["country_code"] }})
                            {{ countrycode["country_name"] }}</a
                          >
                        </div>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        aria-label="Text input with dropdown button"
                        v-model="telephoneNo"
                        @focus="phoneFocus"
                      />
                    </div>
                    <label class="text-center pt-3" v-if="showPhoneValid">Invalid Phone</label>
                  </div>
                  <div class="form-group input1 col-md-7 mt-3 mb-3">
                    <label class="label-text"> Current Password</label>
                    <label
                      class="forgotPassword input1 col-md-7 text-green"
                      @click="forgotPassword"
                    >
                      Forgot password?
                    </label>
                    <input
                      type="password"
                      class="form-control"
                      id="password"
                      v-model="password"
                      @focus="passwordFocus"
                      aria-describedby="password"
                      placeholder="Current Password"
                    />
                    <label class="text-center pt-3" v-if="showPasswordValid"
						>Password can't be blank</label
					>
                  </div>
                </div>
                <div class="row justify-content-center mt-4 mb-3">
                  <div class="col-md-12 text-center">
                    <button
                    
                      v-bind:class="{ disable: disableBtn, notdisabled: enableBtn }"     
                      class="btn btn-lg btn-outline-light ml-lg-2 mt-md-2"
                      v-on:click.stop.prevent="UpdatePhoneNumber"
                    >
                      SAVE
                    </button>
                    <button
                      type="button"
                      @click="deletePhone"
                      class="btn btn-lg btn-light ml-lg-2 mt-md-2"
                    >
                      DELETE PHONE NUMBER
                    </button>
                    <button
                      type="button"
                      @click="cancelChange"
                      class="btn btn-lg btn-light ml-lg-2 mt-md-2"
                    >
                      CANCEL
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
     
    </section>
    
  </div>
</template>

<script>
import CountryCodes from "@/assets/json/CountryCodes.json";
export default {
  name: "UpdatePhone",
  components: {},
  computed: {
    userNotLoggedin() {
      return this.$store.state.user.logedin;
    },
  },

  mounted() {
    window.scroll(0, 0);
  },
watch: {
		telephoneNo(newval, oldval) {
			if (newval.length > 11) {
				this.telephoneNo = oldval;
			}
		},
	},
  created() {
    this.$store.commit("showdefaultFooter", true);
    const config = this.$store.getters.getGlobalConfigs;
    var cont = CountryCodes.find((con) => {
      return con.country_name == config.country_code;
    });
    this.countryCode = cont.country_code;
    this.countryName = cont.country_name;
    this.$store.dispatch("account").then((res) => {
      this.metaData = res.response.profile.metaData;
      this.email = res.response.profile.username;
      this.firstName = res.response.profile.first_name;
      this.lastName = res.response.profile.last_name;
      this.mobileVerified = res.response.profile.mobileVerified;
      this.telephone = res.response.profile.telephone;
      var n =  res.response.profile.metaData.image_id;
      if(n){
         this.n = n 
      } else {
        this.n = this.n
      }
      this.verifyTelephone();
    });
  },

  methods: {
    cancelChange() {
      this.$router.push("/account");
    },

logout() {
      this.$store.dispatch("logout").then((res) => {
        if (res == "true") {
          this.$router.push("/");
        }
      });
    },

    forgotPassword() {
      this.$router.push("/forgotpasswordemail");
    },

    checkVerified() {
      if (this.mobileVerified == false && this.showVerification == true) {
        this.enableBtn = false;
        this.disableBtn = true;
      } else {
        this.enableBtn = true;
        this.disableBtn = false;
      }
    },
    phoneFocus() {
			this.showPhoneValid = false;
		},
		passwordFocus() {
			this.showPasswordValid = false;
		},
    ValidatePhone() {
			var phoneno = /^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/;
			if (this.telephoneNo.match(phoneno)) {
				return true;
			} else {
				this.showPhoneValid = true;
				return false;
			}
		},
		
		ValidPassword() {
			if (this.password == "") {
				this.showPasswordValid = true;
				return false;
			} else {
				return true;
			}
		},
    deletePhone() {
      var self = this;
      var dataToSend = {
        telephone: "",
        metaData: this.metaData,
        firstName: this.firstName,
        lastName: this.lastName,
        email:this.email
      };
      this.$store
        .dispatch("UpdatePhone", dataToSend)
        .then((res) => {
          self.$store.commit("userregmobile", dataToSend.telephone);
          self.$store.commit(
            "setNotification",
            "Phone Number Deleted Succesfully"
          );
          this.$store.dispatch("account").then((res) => {
            this.mobileVerified = res.response.profile.mobileVerified;
            this.telephone = res.response.profile.telephone;
            this.verifyTelephone();
          });
          self.$store.commit("setLoader", false);
        })
        .catch((err) => {
          this.$store.commit("setLoader", false);
          this.$store.commit(
            "setNotification",
            err.response.data.error.message
          );
          this.showupdatepasswordErr = true;
          this.updatepasswordErr = err.response.data.error.message;
        });
    },
    account() {
      this.$router.push("/account");
    },
    gotoAppStore(type) {
      if (type == "google") {
        window.open(
          "https://play.google.com/store/apps/details?id=com.ibakatv.mobile",
          "_blank"
        );
      } else if (type == "apple") {
        window.open(
          "https://apps.apple.com/gm/app/ibakatv/id1060646446",
          "_blank"
        );
      }
    },
    togglePopupNumbers(ev) {
      if (ev == "show") {
        this.showPopupNumbers = true;
      } else {
        this.showPopupNumbers = false;
      }
    },
    gotoSingin() {
      this.$router.push("/login");
    },
    removeErr() {
      this.showresmsg = false;
    },
    verifyTelephone() {
      if (this.telephone) {
        this.showVerification = true;
        this.checkVerified();
      } else {
        this.showVerification = false;
        this.checkVerified();
      }
    },
    verifyNumber() {
      if (!this.telephoneNo) {
        var dataToSend = {
          telephone: this.telephone,
        };
      } else {
        var dataToSend = {
          telephone: this.countryCode + "" + this.telephoneNo,
        };
      }
      this.$store
        .dispatch("triggerSMSverify", dataToSend)
        .then((res) => {
          if (res) {
            this.$store.commit("setNotification", res.message);
            this.$store.commit("setLoader", false);
            this.$store.commit("setShowOtpTimer",true);
            this.$router.push("/verifyupdatephone");
          }
        })
        .catch((err) => {
          this.$store.commit("setLoader", false);
          this.$store.commit(
            "setNotification",
            err.response.data.error.message
          );
        });
    },
    UpdatePhoneNumber() {
     if (this.ValidatePhone() == true && this.ValidPassword() == true) { 
      var self = this;
      var dataToSend = {
        id: this.email,
        password: this.password,
        type: "email",
      };
      this.$store.commit("setLoader", true);
      this.$store
        .dispatch("login", dataToSend)
        .then((res) => {
          var dataToSend = {
            telephone: this.countryCode + "" + this.telephoneNo,
            metaData: this.metaData,
            firstName: this.firstName,
            lastName: this.lastName,
            email:this.email
          };
          this.$store
            .dispatch("UpdatePhone", dataToSend)
            .then((res) => {
              self.$store.commit("userregmobile", dataToSend.telephone);
              self.$store.commit("setNotification", res.message);
              this.verifyNumber();
              self.$store.commit("setLoader", false);
            })
            .catch((err) => {
              this.$store.commit("setLoader", false);
              this.$store.commit(
                "setNotification",
                err.response.data.error.message
              );
              this.showupdatepasswordErr = true;
              this.updatepasswordErr = err.response.data.error.message;
            });
        })
        .catch((err) => {
          self.$store.commit("setLoader", false);
          self.$store.commit(
            "setNotification",
            err.response.data.error.message
          );
        });
     }
    },
    onCountryCodeClicked(countrycode) {
      this.countryCode = countrycode.country_code;
      this.countryName = countrycode.country_name;
    },
  },

  data() {
    return {
      n: 0,
      showPopupNumbers: false,
      telephone: "",
      isActive: false,
      countrycodes: CountryCodes,
      countryCode: "",
      countryName: "",
      mobileVerified: false,
      showVerification: false,
      password: "",
      email: "",
      firstName: "",
      lastName: "",
      metaData: {},
      telephoneNo: "",
      enableBtn: false,
      disableBtn: true,
      showPhoneValid: false,
			showPhoneValidErr: "Invalid Phone",
			showPasswordValid: false,
			showPasswordValidErr: "Password can't be blank",
      
    };
  },
};
</script>
<style scoped>
.emailhead {
  font-size: 15px;
  color: var(--text-primary-color);
  align-items: center !important;
  text-align: center;
  margin-top: 10px;
}

.verifybtn {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}

.error-icon {
  top: -10px !important;
  margin-right: 3px;
  transform: translate(-50%, -12%);
}

.btn-verify {
  background-color: rgb(43, 42, 42);
  color: rgb(255, 255, 255) !important;
}

.btn-verify:hover, .btn-primary:focus {
  background-color: rgb(43, 42, 42) !important;
  color: rgb(255, 255, 255) !important;
  border-color: var(--btn-outline-dark-border-color);
}

.forgotPassword {
  cursor: pointer;
  right: -95px;
}

.disable {
  cursor: pointer;
  background-color: #679F3D  !important;
    border-color: #F1F2F2;
    
    color: #F1F2F2;
}


.py-5{
  padding-top: 8rem !important;
  padding-bottom: 8rem !important;
 min-height: 80vh;
}

</style>